import { DataTransferType } from '../../behavior/Clipboard/utils';
import { cbType, codeBlockLangAttr } from './const';
export const handlePaste = (view, e) => {
    if (!e.clipboardData || view.state.selection.$from.parent.type.spec.code)
        return false;
    const code = getCodeData(e.clipboardData);
    if (!code)
        return false;
    let tr = view.state.tr;
    const { schema } = tr.doc.type;
    const codeBlockNode = cbType(schema).create({ [codeBlockLangAttr]: code.mode }, schema.text(code.value));
    tr = tr.replaceSelectionWith(codeBlockNode);
    view.dispatch(tr.scrollIntoView());
    return true;
};
function getCodeData(data) {
    var _a;
    if (data.getData(DataTransferType.Text)) {
        let editor = 'unknown';
        let mode;
        if (isVSCode(data)) {
            editor = 'vscode';
            mode = (_a = tryCatch(() => JSON.parse(data.getData(DataTransferType.VSCodeData)))) === null || _a === void 0 ? void 0 : _a.mode;
        }
        else
            return null;
        return { editor, mode, value: data.getData(DataTransferType.Text) };
    }
    return null;
}
function isVSCode(data) {
    return data.types.includes(DataTransferType.VSCodeData);
}
function tryCatch(fn) {
    try {
        return fn();
    }
    catch (e) {
        console.error(e);
    }
    return undefined;
}
